import { DefaultSelection } from '../../components/common/table/common';
import DisplayLabels from '../../components/pages/labels/DisplayLabels';
import { dateHeader, formatCellDate } from './timeModeCell';
import { linkTo } from '../linkTo';

export const makeEquipmentListColumn = () => {
  const col = [
    DefaultSelection,
    {
      header: 'Serial Number',
      accessorKey: 'serialNumber',
      enableColumnFilter: true,
      size: 100,
      style: { textAlign: 'center' },
      cell: ({ row }) => linkTo('/equipment', row.original.id, row.original.serialNumber),
    },
    {
      header: 'Type',
      accessorKey: 'type',
      size: 50,
      style: { textAlign: 'center' },
      cell: ({ row }) => row.original.typeDescr,
    },
    {
      header: 'ULD Group',
      accessorKey: 'uldGroupIataCode',
      enableColumnFilter: false,
      size: 80,
      style: { textAlign: 'center' },
    },
    {
      header: 'Station',
      accessorKey: 'toStationIataCode',
      enableColumnFilter: true,
      size: 60,
      style: { textAlign: 'center' },
    },
    {
      header: 'Status',
      accessorKey: 'status',
      enableColumnFilter: false,
      size: 80,
      cell: ({ row }) => row.original.statusDescr,
    },
    {
      header: 'Pool Name',
      accessorKey: 'poolName',
      enableColumnFilter: true,
      disableSortBy: true,
      size: 70,
      style: { textAlign: 'center' },
    },
    {
      header: 'Condition',
      accessorKey: 'condition',
      enableColumnFilter: true,
      size: 70,
      style: { textAlign: 'center' },
    },
    {
      header: dateHeader('Date'),
      accessorKey: 'logDateTime',
      enableColumnFilter: false,
      size: 100,
      cell: ({ row, table }) => formatCellDate(table, row.original.logDateTime),
    },
    {
      header: 'DeviceId',
      accessorKey: 'deviceId',
      enableColumnFilter: false,
      size: 150,
      cell: ({ row }) => linkTo('/devices', row.original.deviceId, row.original.deviceId),
    },
    {
      header: dateHeader('Last Seen Date'),
      accessorKey: 'lastSeenDateTime',
      enableColumnFilter: false,
      size: 110,
      style: { textAlign: 'center' },
      cell: ({ row, table }) => formatCellDate(table, row.original.lastSeenDateTime),
    },
    {
      header: 'Mov. Type',
      accessorKey: 'movementType',
      enableColumnFilter: false,
      size: 90,
      style: { textAlign: 'center' },
    },
    {
      header: 'Network',
      accessorKey: 'networkCarrierCode',
      enableColumnFilter: true,
      size: 60,
      style: { textAlign: 'center' },
    },
    {
      header: 'Supplier Name',
      accessorKey: 'supplierName',
      enableColumnFilter: true,
      size: 160,
      style: { textAlign: 'center' },
    },
    {
      header: 'Part Number',
      accessorKey: 'partNumber',
      enableColumnFilter: true,
      size: 160,
      style: { textAlign: 'center' },
    },
    {
      header: dateHeader('Last Message'),
      accessorKey: 'msgDateTime',
      enableColumnFilter: false,
      size: 110,
      style: { textAlign: 'center' },
      cell: ({ row, table }) => formatCellDate(table, row.original.msgDateTime),
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
    {
      header: dateHeader('Modified'),
      accessorKey: 'modifiedDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.modifiedDateTime),
    },
    {
      header: 'Labels',
      accessorKey: 'labels',
      disableSortBy: true,
      enableColumnFilter: true,
      size: 'auto',
      style: { textAlign: 'left' },
      cell: ({ row }) => <DisplayLabels labels={row.original.labels} />,
    },
  ] as Array<any>;

  return col;
};
